<aside>
    <nav>
        <h3 class="header"> Introduction </h3>
        <a href="#about-this-app"> About this App </a>
        
        <h3 class="header"> Tutorials </h3>
        <a href="#sorting-tutorial"> Sorting Visualizer Tutorial </a>
        <a href="#searching-tutorial"> Searching Visualizer Tutorial </a>
        <a href="#path-finding-tutorial"> Path Finding Visualizer Tutorial </a>

        <h3 class="header"> Give A Star </h3>
        <a target="_blank" href="https://github.com/jeevana1234/ALGO_Analyzer"> Source Code </a>
        <a target="_blank" href="https://github.com/jeevana1234"> Maddela Jeevana </a>

        <br>

        
    </nav>
</aside>

<style>
    aside {
        padding: 0 .5rem;
    }
    .header {
        margin: 2rem 0 1rem 0;
    }
    nav a {
        display: block;
        margin: .75rem 0;
    }
    nav a:hover {
        text-decoration: none;
        color: var(--brand);
    }
    p a {
        display: inline;
        color: dodgerblue;
    }
</style>